import React, { useState, useEffect, memo } from "react";
import "../HeaderComponent/HeaderStyle.css";
import MultiLayerHeader from "./MultiLayerHeader";
import { useUserContext } from "../../../contextapi/UserContext";
import ErrorBoundary from "../../ErrorBoundary/ErrorBoundary";
import { Container, Group, Paper, Skeleton } from "@mantine/core"; // You can use Mantine's Skeleton or any other loader
import { doc, getDoc, setDoc } from "firebase/firestore";
import { db } from "../../../firebase/FirebaseCredential";
import { useAppDispatch, useAppSelector } from "../../../hooks/hooks";
import { setRolePermissions } from "../../../features/rolePermissionsSlice";
import { RootState } from "../../../store/store";

function Header() {
  const { profileDetails, roleDetails } = useUserContext();
  const [headerLoaded, setHeaderLoaded] = useState(false); // Track if header has loaded
  const [navigationData, setNavigationData] = useState([]);
  const roleType = useAppSelector(
    (state: RootState) => state.session.role_type
  );

  useEffect(() => {
    if (roleType) {
      fetchRolePermission(roleType);
    }
  }, [roleType, profileDetails]);

  const fetchRolePermission = async (roletype: string) => {
    setHeaderLoaded(true); // Show loader while fetching data
    try {
      const docRef = doc(db, "defaultnavlinks", roletype);
      const docSnapshot = await getDoc(docRef);

      if (docSnapshot.exists()) {
        const data = docSnapshot.data();
        setNavigationData(data?.nav_link || []);
      } else {
        console.log("No such document exists!");
        setNavigationData([]); // Ensure category is reset to an empty array
      }
    } catch (error) {
      console.error("Error fetching role permission document:", error);
      setNavigationData([]); // Reset category on error
    } finally {
      setHeaderLoaded(false); // Hide loader once data is fetched
    }
  };

  return (
    <ErrorBoundary>
      <div
        style={{
          position: "sticky",
          top: 0,
          zIndex: 100,
        }}
      >
        {headerLoaded ? (
          <Paper p={"xs"}>
            <Container size={"lg"}>
              <Group position="apart" mt={12}>
                <Skeleton height={30} width="200px" radius="md" animate />
                <Skeleton circle height={30} width={30} animate />
              </Group>

              {/* Second row: Navigation links */}
              <Group mt={48} mb={12}>
                <Skeleton height={10} width="100px" radius="md" animate />
                <Skeleton height={10} width="100px" radius="md" animate />
                <Skeleton height={10} width="100px" radius="md" animate />
                <Skeleton height={10} width="100px" radius="md" animate />
                <Skeleton height={10} width="100px" radius="md" animate />
                <Skeleton height={10} width="100px" radius="md" animate />
                <Skeleton height={10} width="100px" radius="md" animate />
                <Skeleton height={10} width="100px" radius="md" animate />
              </Group>
            </Container>
          </Paper>
        ) : (
          <MultiLayerHeader user={profileDetails} mainLinks={navigationData} />
        )}
      </div>
    </ErrorBoundary>
  );
}

export default Header;
